/**
 * Servicio para manejar redirecciones a la página de acceso denegado
 */
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ForbiddenService {
  // Almacena la URL que causó el error de acceso denegado
  private lastAttemptedUrl: string | null = null;

  constructor(private router: Router) {}

  /**
   * Redirige al usuario a la página de acceso denegado
   * @param attemptedUrl URL que causó el error de acceso denegado
   */
  redirectToForbiddenPage(attemptedUrl?: string): void {
    if (attemptedUrl) {
      this.lastAttemptedUrl = attemptedUrl;
    }
    this.router.navigate(['/auth/403']);
  }

  /**
   * Obtiene la última URL que causó el error de acceso denegado
   * @returns La última URL intentada o null si no hay ninguna
   */
  getLastAttemptedUrl(): string | null {
    return this.lastAttemptedUrl;
  }

  /**
   * Limpia la última URL intentada
   */
  clearLastAttemptedUrl(): void {
    this.lastAttemptedUrl = null;
  }
}
